module.exports = __webpack_public_path__ + "fonts/barlow-v5-latin-500.633f43a.woff";